/**
 * 注意，下载图片应该是在同源环境，否则会直接打开
 * @param {*} url
 * @param {*} name
 */
export function downloadByJs(url, name) {
  if (url && name) {
    let DOM_A = document.createElement('a');
    const DOM_BODY = document.querySelector('body')
    // DOM_A.href = url;
    // DOM_A.download = name;
    DOM_A.setAttribute("href", url);
    DOM_A.setAttribute("target", '_self');
    DOM_A.setAttribute("download", name)
    DOM_BODY.appendChild(DOM_A);
    DOM_A.click();
    setTimeout(() => {
      // 3秒后移除dom
      DOM_BODY.removeChild(DOM_A)
    },3000)
  } else {
    console.error('下载信息异常/n', 'url:', url, 'name:', name)
  }
}

// 两个时间戳，返回相差月份 例如：1月到2月  返回个1，注：如果是首尾都要计算进去的话 要给结果+1
export function calculateMonthDifference(timestamp1, timestamp2) {
  const date1 = new Date(timestamp1);
  const date2 = new Date(timestamp2);
  
  // 计算相差的年份和月份
  const yearDifference = date2.getFullYear() - date1.getFullYear();
  const monthDifference = date2.getMonth() - date1.getMonth();
  
  // 计算总相差月份
  const totalMonthDifference = (yearDifference * 12) + monthDifference ;
  
  return totalMonthDifference;
}

// 若干个时间段，判断这些时间段是否存在交集
export function hasOverlap(timePeriods) {
  // 首先对时间段按开始时间排序
  timePeriods.sort((a, b) => a.start - b.start);
  
  // 检查相邻时间段是否有交集
  for (let i = 0; i < timePeriods.length - 1; i++) {
    if (timePeriods[i].end > timePeriods[i + 1].start) {
      return true; // 存在交集
    }
  }
  return false; // 不存在交集
}

// 若干个时间段，判断某个时间戳是否在任一时间段内
export function isTimestampInRange(timestamp, timePeriods) {
  for (let period of timePeriods) {
    if (timestamp >= period.start && timestamp <= period.end) {
      return true; // 时间戳在某个时间段内
    }
  }
  return false; // 时间戳不在任何时间段内
}

// 传一个时间戳 返回一下该月最后一天时间戳
export function getLastDayOfMonth(timestamp) {
  // 创建一个新的Date对象
  const date = new Date(timestamp);
  
  // 设置日期为下个月的第一天
  date.setMonth(date.getMonth() + 1);
  date.setDate(0);
  
  // 返回该月最后一天的时间戳
  return date.getTime();
}
